import * as React from "react";
import { connect } from "react-redux";

import * as actions from "../../actions";
import {
  TextInput as TextInputComponent,
  TextInputProps as TextInputComponentProps,
} from "../../components/TextInput/TextInput";
import { StoreState } from "../../reducers";
import { getWidgetFormErrors } from "../../reducers/methods";

interface TextInputProps extends TextInputComponentProps {
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  setWidgetFormError: typeof actions.setWidgetFormError;
  setUserInput: typeof actions.setUserInput;
}

class TextInput extends React.Component<TextInputProps> {
  render() {
    const { setWidgetFormError, setUserInput } = this.props;

    return (
      <TextInputComponent
        {...this.props}
        onFormError={setWidgetFormError}
        onFormChange={setUserInput}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  formErrors: getWidgetFormErrors(state),
});

export default connect(mapStateToProps, {
  clearWidgetFormError: actions.clearWidgetFormError,
  setWidgetFormError: actions.setWidgetFormError,
  setUserInput: actions.setUserInput,
})(TextInput);
